import { SporsmalType } from '../../types/generated-types';
import { CurrentSporsmal } from '../reducer/current-steg';

export const getTitle = (currentSporsmalList: CurrentSporsmal[], id: string): string => {
    const currentSporsmal: CurrentSporsmal = currentSporsmalList.find((sporsmal) => sporsmal.sporsmal.id === id);

    switch (currentSporsmal?.type) {
        case SporsmalType.Radio:
            return currentSporsmal.sporsmal.alternativer.find((a) => a.id === currentSporsmal.svarId)?.tekst;

        case SporsmalType.SimpleKontaktinfo:
            return currentSporsmal.fulltNavn;

        case SporsmalType.Tekst:
            return currentSporsmal.svarTekst;

        case SporsmalType.Select:
            return currentSporsmal.sporsmal.alternativer.find((alternativ) => alternativ.id === currentSporsmal.svarId)
                ?.tekst;

        case SporsmalType.KontaktInfoInvolvert:
            return currentSporsmal.navn;

        case SporsmalType.Tall:
            return `${currentSporsmal.tall} ${currentSporsmal.maleenhet}`;

        default:
            return undefined;
    }
};
